import { render, staticRenderFns } from "./Najava.vue?vue&type=template&id=0260d491&scoped=true"
import script from "./Najava.vue?vue&type=script&lang=js"
export * from "./Najava.vue?vue&type=script&lang=js"
import style0 from "./Najava.vue?vue&type=style&index=0&id=0260d491&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0260d491",
  null
  
)

export default component.exports